import "core-js/es/array/flat-map";
// @ts-ignore
import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();

// IE9+ Element.closest polyfill: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
if (!Element.prototype.matches) {
    Element.prototype.matches =
        (Element.prototype as any).msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function closest(s: string) {
        let el = this;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || (el.parentNode as Element);
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
